import { __decorate } from "tslib";
import { css, html, LitElement, nothing } from 'lit';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { customElement, property } from 'lit/decorators.js';
let button = class button extends LitElement {
    constructor() {
        super(...arguments);
        this.noStyles = false;
        this.arrow = false;
        this.backgroundColor = 'transparent';
        //create function to dispatch event
        this.handlebuttonClick = (value) => {
            this.dispatchEvent(new CustomEvent('button-click', {
                detail: { value },
                bubbles: true,
                composed: true,
            }));
        };
    }
    render() {
        return html `<button
      style=${`background-color: ${this.backgroundColor}`}
      @click=${() => this.handlebuttonClick(true)}
    >
      ${this.arrow ? html `<div class="little-arrow"></div>` : nothing}
      <slot></slot>
    </button>`;
    }
};
button.styles = css `
    :host {
      display: inline-block;
    }
    button {
      appearance: none;
      border: 0;
      padding: 0;
      background-color: transparent;
      transition: all 0.2s ease-in-out;
      cursor: pointer;
      position: relative;
    }
    .little-arrow {
      position: absolute;
      bottom: calc(100% + 7px);
      right: 50%;
      width: 0px;
      height: 0px;
      border-left: 6px solid transparent;
      border-right: 6px solid transparent;
      border-top: 5px solid #fff;
      z-index: 3;
      transform: translateX(50%);
    }
  `;
__decorate([
    property({ type: Boolean })
], button.prototype, "noStyles", void 0);
__decorate([
    property({ type: Boolean })
], button.prototype, "arrow", void 0);
__decorate([
    property({ type: String })
], button.prototype, "backgroundColor", void 0);
button = __decorate([
    customElement('sg-icon-button')
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
], button);
export { button };
//# sourceMappingURL=button.js.map